import { render, staticRenderFns } from "./TrainingItemSingle.vue?vue&type=template&id=47506863&scoped=true&"
import script from "./TrainingItemSingle.vue?vue&type=script&lang=js&"
export * from "./TrainingItemSingle.vue?vue&type=script&lang=js&"
import style0 from "./TrainingItemSingle.vue?vue&type=style&index=0&id=47506863&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47506863",
  null
  
)

export default component.exports